import { SafeAreaView } from "react-native-safe-area-context";

import { NetworkAvailabilityMessage } from "@/constants/Network";
import { TextTestID } from "@/constants/TestID";
// Direct imports avoid evaluating the @/ui/core barrel, which pulls in all IconDefinitions at startup
import Icon from "@/ui/core/Icon";
import { FAIconName } from "@/ui/core/Icon/IconDefinitions";
import Text from "@/ui/core/Text";
import { Box, HStack, StatusBarPadding, VStack } from "@/ui/layout";
import { ShadowStyles } from "@/ui/theme/styles";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

const baseTestID = "network-status-banner";

const NetworkStatusBanner = () => {
  return (
    <Box
      backgroundColor={ColorToken.NotificationCriticalBackground}
      paddingHorizontal={24}
      paddingVertical={20}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...ShadowStyles}
    >
      {/*
     StatusBarPadding needs to be inside this shadowStyles Box for the padding to be within the shadowed borders of this header

     Additionally, no paddingHorizontal or paddingVertical can be applied to the outer Box containing StatusBarPadding,
     as StatusBarPadding will only render if it is at the very top of the of the screen, which vertical or horizontal padding will make untrue
   */}
      <StatusBarPadding />
      <SafeAreaView />
      <HStack alignItems="center" gap={18} justifyContent="space-between">
        <VStack alignItems="flex-start" flexShrink={1} gap={2}>
          <Text
            color={ColorToken.NeutralPrimary}
            testID={joinTestIDs(baseTestID, TextTestID.Title)}
            textAlign="center"
            variant="bodyMedium"
          >
            {NetworkAvailabilityMessage.title}
          </Text>
          <Text
            color={ColorToken.NeutralPrimary}
            testID={joinTestIDs(baseTestID, TextTestID.Description)}
            textAlign="center"
            variant="caption"
          >
            {NetworkAvailabilityMessage.description}
          </Text>
        </VStack>
        <Icon
          color={ColorToken.NotificationCriticalText}
          name={FAIconName.ExclamationTriangle}
          size="lg"
          testID={baseTestID}
        />
      </HStack>
    </Box>
  );
};

export default NetworkStatusBanner;
